/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Show_All_ColumnsInputs */

const en_show_all_columns = /** @type {(inputs: Show_All_ColumnsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show all`)
};

const nl_show_all_columns = /** @type {(inputs: Show_All_ColumnsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toon alles`)
};

/**
* | output |
* | --- |
* | "Show all" |
*
* @param {Show_All_ColumnsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const show_all_columns = /** @type {((inputs?: Show_All_ColumnsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Show_All_ColumnsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_show_all_columns(inputs)
	return en_show_all_columns(inputs)
});